import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_CARD } from "../queries/useQueryCard";
import { QUERY_CARDS } from "../queries/useQueryCards";
import { closeCard } from "../../../services/api/banking/cards/closeCard";

export const useMutationCloseCard = () =>
  useWSMutation<cardApiSpec.Card, WSServiceError, string>(closeCard, {
    dependencies(response, cardId) {
      return [[QUERY_CARD, cardId], QUERY_CARDS];
    }
  });
